import React from 'react'
import bg from '../assets/bg-home.jpg'
import {Link as Scroll} from 'react-scroll'

const Hero = () => {
  return (
    <div className='flex mx-auto !z-10 pt-14 sm:pt-28'>
        <div className='text-center absolute !z-10 w-full pt-10 px-5 lg:pt-28'>
          <div className='max-w-[460px] px-2 sm:px-5 md:px-10 mx-auto bg-white py-2 sm:py-5 bg-opacity-80 rounded-xl'>
            <h1 className='uppercase font-semibold text-xl md:text-3xl'>Nasze motto</h1>
            <p className='text-sm sm:text-base'>Dlaczego frma konsulingowa <b className='font-semibold'>ONIKO-EXPERT</b>?</p>
            <p className='text-sm sm:text-base pt-3'>Nie można znać się na wyszystkim ale można wiedzieć gdzie się z tym wszystkim udać.
            Jeśli czegoś nie wiesz - pytaj, bo kto pyta już nie błądzi.</p>
            <button className='bg-[#4C4C9B] mt-5 px-2 py-1 sm:py-2 rounded-xl hover:scale-95 duration-500'>
              <Scroll 
              to="dlaczegomy" 
              className='text-sm sm:text-base text-white font-semibold'
              spy={true} smooth={true} offset={-200} duration={500}
              >
                Dlaczego My?
              </Scroll>
            </button>
          </div>
        </div>
        <div className='w-full'>
          <img src={bg} alt="background" className='object-cover w-full max-h-[350px] lg:max-h-[450px]'/>
        </div>
    </div>
  )
}

export default Hero